import styled from 'styled-components';

export const PaginationButton = styled.button`
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 6px 10px;
  background: var(--color-surface);
  color: var(--color-accent);
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:not(:disabled):hover {
    background: var(--color-surface-muted);
  }
`;
